import chroma from 'chroma-js';

export const applyHslDiff = (
	srcColor: string,
	originalSrcColor: string,
	originalDstColor: string,
	options?: {
		resS?: number;
		resL?: number;
	}
) => {
	const [ha, sa, la] = chroma(originalSrcColor).hsl();
	const [hb, sb, lb] = chroma(originalDstColor).hsl();

	const hueDiff = hb - ha;
	const sDiffRelative = (sb - sa) / sa;
	const LDiff = lb - la;
	const colorHsl = chroma(srcColor).hsl();

	const resColor = chroma.hsl(
		colorHsl[0] + hueDiff,
		options?.resS ?? colorHsl[1] + colorHsl[1] * sDiffRelative,
		options?.resL ?? colorHsl[2] + LDiff
	);

	return resColor.hex();
};
